//import areas from '../frontend/data/focus-areas';
// import ArrowRight from '../frontend/assets/arrow-right.svg';
import TextView from "../TextView/TextView";

type FocalPoint = {
  x: number;
  y: number;
};

interface focusAreaItem {
  title?: string;
  description?: string;
  url?: string;
  image?: string;
  imageAlt?: string;
  focalPoint?: FocalPoint;
}

export default function FocusAreas({
  titleFocusAreas,
  areas,
}: {
  titleFocusAreas: string;
  areas: focusAreaItem[];
}) {
  return (
    <>
      {titleFocusAreas && (
        <div className="focus-areas-title">
          <h2>{titleFocusAreas}</h2>
        </div>
      )}

      <div className="focus-areas">
        {areas.map(
          ({ title, description, url, image, imageAlt, focalPoint }, idx) => {
            const external = !!url?.match(/^https?:/);

            let imgStyle: React.CSSProperties | undefined;
            if (focalPoint?.x != null && focalPoint?.y != null) {
              const x = Math.round(focalPoint.x * 100);
              const y = Math.round(focalPoint.y * 100);
              imgStyle = {
                width: "100%",
                height: "100%",
                objectFit: "cover",
                objectPosition: `${x}% ${y}%`,
              };
            }

            return (
              <a
                key={idx}
                href={url}
                target={external ? "_blank" : undefined}
                rel={external ? "noreferrer" : undefined}
              >
                <article>
                  <div>
                    <h3>{title}</h3>
                    {!!description && <TextView text={description} />}
                    <span></span>
                  </div>
                  <figure>
                    <img src={image} alt={imageAlt} style={imgStyle} />
                  </figure>
                </article>
              </a>
            );
          },
        )}
      </div>
    </>
  );
}
